import axios from "../apis/Api";
const MAX_FILESIZE=2097152;
export const uploadFile = async (file) => {
  return new Promise(async (resolve, reject)=>{

    const guidFileName = (filename) => {
      var fileExt = filename.split(".").pop();
      let uuid = "xxxxxxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
      return uuid + "." + fileExt;
    }

    const getPreSignedUrl=async (fileName)=> {
      return new Promise(async (resolve, reject)=>{
      axios.get(`api/Authenticate/GetPreSignedURL/${fileName}`)
      .then(async ({ data }) => {
        return resolve(data.response);
      })
      .catch((error) => {
        return reject("");
      });
      })
    }
    if(file.size > MAX_FILESIZE)
    {
      //toast.error()
      return reject("File size should be less than 2Mbs");
    }
    let fileName=guidFileName(file.name)
    let presignedUrl=await getPreSignedUrl(fileName);   
    if(presignedUrl !== "")
    {
    const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers:{
          "Content-Type": file.type 
        },
        body: file
    });

    if(response.ok){
      return resolve(response.url.split('?X-Amz-Expires')[0]);
    }else{
      return reject("Image upload failed");
    }
  }else{
    return reject("Image upload failed");
  }
});
}
